export const availableCaterings = [
    { value: "ÜN", description: "Übernachtung" },
    { value: "ÜF", description: "Übernachtung mit Frühstück" },
    { value: "HP", description: "Halbpension" },
    { value: "3/4", description: "3/4 Pension" },
    { value: "VP", description: "Vollpension" },
    { value: "AI", description: "All-Inclusive" },
]
